import { AsphaltLotReportItem } from '../classes/asphalt'

export const AsphaltCoreSheet = new AsphaltLotReportItem({
  id: 'b5196d99-9d6c-4f7c-8323-2b7c3f146131',
  name: 'Asphalt Core Sheet',
  queryParameter: 'asphalt-core',
  sampleFilename: 'asphalt-core-sheet',
  description: 'CORE-SHEET',
})

export const AsphaltLot = new AsphaltLotReportItem({
  id: '448a01fe-bb77-45ac-ab3d-e76c5c3d8ccc',
  name: 'Asphalt Lot',
  queryParameter: 'asphalt-lot',
  sampleFilename: 'asphalt-lot',
  description: 'LOT',
})

export type AsphaltReportItem = typeof AsphaltCoreSheet | typeof AsphaltLot
